// extracted by mini-css-extract-plugin
export const header = "header-module--header--2ea3u";
export const logoWrapper = "header-module--logoWrapper--23403";
export const small = "header-module--small--E7nZW";